'use client';

import Image from 'next/image';
import { useRef } from 'react';
import MinimalHeaderPage from '@alltrails/layout/components/MinimalHeaderPage';
import type { Plan } from '@alltrails/types/Plan';
import FrequentlyAskedQuestions from '../FrequentlyAskedQuestions';
import GiftingHeader from '../GiftingHeader';
import GiftValuePanel from '../GiftValuePanel';
import GiveAllTrailsBanner from '../GiveAllTrailsBanner';
import OnePercentForThePlanet from '../OnePercentForThePlanet';
import styles from './GiftLandingPage.module.scss';
import overlook2800Avif from './scenic-overlook-2800w.avif';

type Props = {
  plan: Plan;
};

const GiftLandingPage = ({ plan }: Props) => {
  const buyGiftButtonRef = useRef<HTMLAnchorElement>(null);

  const scrollToTop = () => {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    buyGiftButtonRef.current?.focus();
  };

  return (
    <MinimalHeaderPage disableInAppMessages hideReturningUserUpsell>
      <GiftingHeader plan={plan} buyGiftButtonRef={buyGiftButtonRef} />
      <GiftValuePanel />
      <FrequentlyAskedQuestions />
      <OnePercentForThePlanet />
      <GiveAllTrailsBanner handleClick={scrollToTop} />
      <Image alt="" className={styles.img} src={overlook2800Avif} />
    </MinimalHeaderPage>
  );
};

export default GiftLandingPage;
